import { CLIENT_NAME } from "../../constants";
import { CALL_API } from "../api.middleware";
import {
	FETCH_BOOKINGS,
	FETCH_BOOKINGS_FAILED,
	FETCH_BOOKINGS_SUCCESS,
	GET_BOOKINGS,
	GET_BOOKINGS_FAILED,
	GET_BOOKINGS_SUCCESS,
	SAVE_BOOKING,
	GET_RESERVATIONS_STATUS,
	GET_RESERVATIONS_STATUS_SUCCESS,
	GET_RESERVATIONS_STATUS_FAILED,
	GET_RESERVATIONS_FEEDBACK,
	GET_RESERVATIONS_FEEDBACK_SUCCESS,
	GET_RESERVATIONS_FEEDBACK_FAILED,
	SAVE_BOOKING_FAILED,
	SAVE_BOOKING_SUCCESS,
	SAVE_RESERVATION,
	SAVE_RESERVATION_SUCCESS,
	SAVE_RESERVATION_FAILED,
	UPLOAD_BOOKING_IMAGE,
	UPLOAD_BOOKING_IMAGE_SUCCESS,
	UPLOAD_BOOKING_IMAGE_FAILED,
	DELETE_BOOKING_IMAGE,
	DELETE_BOOKING_IMAGE_SUCCESS,
	DELETE_BOOKING_IMAGE_FAILED,
	RESCHEDULE,
	RESCHEDULE_SUCCESS,
	RESCHEDULE_FAILED,
	DELETE_BOOKING_TRANSACTION,
	DELETE_BOOKING_TRANSACTION_SUCCESS,
	DELETE_BOOKING_TRANSACTION_FAILED,
	GET_BOOKING_EVENTS,
	GET_BOOKING_EVENTS_SUCCESS,
	GET_BOOKING_EVENTS_FAILED,
	GET_WORKSHOP_IMAGES,
	GET_WORKSHOP_IMAGES_SUCCESS,
	GET_WORKSHOP_IMAGES_FAILED,
	SAVE_PREBOOK_IMAGE,
	SAVE_PREBOOK_IMAGE_SUCCESS,
	SAVE_PREBOOK_IMAGE_FAILED,
	DELETE_PREBOOK_IMAGE,
	DELETE_PREBOOK_IMAGE_SUCCESS,
	DELETE_PREBOOK_IMAGE_FAILED,
	FETCH_FEEDBACK_QUESTIONS,
	FETCH_FEEDBACK_QUESTIONS_SUCCESS,
	FETCH_FEEDBACK_QUESTIONS_FAILED,
	SAVE_FEEDBACK,
	SAVE_FEEDBACK_SUCCESS,
	SAVE_FEEDBACK_FAILED,
	CALL_BACK_RAZORPAY,
	CALL_BACK_RAZORPAY_SUCCESS,
	CALL_BACK_RAZORPAY_FAILED,
	LOGOUT_SUCCESS,
	GET_BOOKING_SUMMARY,
	GET_BOOKING_SUMMARY_SUCCESS,
	GET_BOOKING_SUMMARY_FAILED,
	SAVE_BOOKING_DET_HEADER_STATUS,
	UPDATE_BOOKING_SUMMARY,
	CLEAR_PARTICULAR_BOOKING,
	GET_ADVANCE_ORDERID,
	GET_ADVANCE_ORDERID_SUCCESS,
	GET_ADVANCE_ORDERID_FAILED,
	GET_FEEDBACK,
	GET_FEEDBACK_SUCCESS,
	GET_FEEDBACK_FAILED,
	UPDATE_PARTICULAR_BOOKING_DETAILS,
	UPDATE_RESERVATION_PARTICULAR_BOOKING_DETAILS,
	CLEAR_BOOKING_IMAGES,
	CLEAR_SAVED_FEEDBACK_STATUS,
	// SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS,
	// SAVE_VEHICLE_BOOKING_IMAGE_FAILED,
	// SAVE_VEHICLE_BOOKING_IMAGE,
	// BOOKING_IMAGE,
} from "../Types";

export const saveBookingTransaction = (payload) => async (dispatch) => {
	try {
		// console.log("Payload");
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/bookings`,
				method: "POST",
				body: payload,
				types: [SAVE_BOOKING, SAVE_BOOKING_SUCCESS, SAVE_BOOKING_FAILED],
				showLoader: true,
				showToast: true,
				toastMessage: "Booked Successfully",
			},
		});
	} catch (error) {
		// alert("B90 = " + `${error}`);
		console.error("Book - 91", error);
	}
};

export const saveReservations = (payload) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/reservations`,
				method: "POST",
				body: payload,
				types: [SAVE_RESERVATION, SAVE_RESERVATION_SUCCESS, SAVE_RESERVATION_FAILED],
				showLoader: true,
				otherUrl: true,
			},
		});
	} catch (error) {
		// alert("B107 = " + `${error}`);
		console.error("Book - 109", error);
	}
};

export const fetchBookingWithId = (bookingId) => async (dispatch) => {
	try {
		// console.log("fetchBookingWithId == ", bookingId);
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${bookingId}`,
				method: "GET",
				types: [FETCH_BOOKINGS, FETCH_BOOKINGS_SUCCESS, FETCH_BOOKINGS_FAILED],
				showLoader: false,
			},
		});
	} catch (error) {
		// alert("B120 = " + `${error}`);
		console.error("Book - 126", error);
	}
};

export const fetchBookings = () => async (dispatch) => {
	try {
		// console.log("fetchBookings == ALL");
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/bookings`,
				method: "GET",
				types: [GET_BOOKINGS, GET_BOOKINGS_SUCCESS, GET_BOOKINGS_FAILED],
				showLoader: false,
				additionalData: {
					showError: false,
				},
			},
		});
	} catch (error) {
		// alert("B140 = " + `${error}`);
		console.error("Book - 146", error);
	}
};

// export const fetchReservations = (registrationNo) => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/getServiceTicketStatus?vehicleNumber=${registrationNo}`,
//         method: "GET",
//         types: [
//           GET_RESERVATIONS_STATUS,
//           GET_RESERVATIONS_STATUS_SUCCESS,
//           GET_RESERVATIONS_STATUS_FAILED,
//         ],
//         showLoader: true,
//         otherUrl: true,
//         additionalData: {
//           showError: false,
//         },
//       },
//     });
//   } catch (error) {
//     alert("B163 = " + `${error}`);
//   }
// };

export const uploadBookingImage = (id, body) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}/images`,
				method: "POST",
				types: [
					UPLOAD_BOOKING_IMAGE,
					UPLOAD_BOOKING_IMAGE_SUCCESS,
					UPLOAD_BOOKING_IMAGE_FAILED,
				],
				body,
				isForm: true,
				showLoader: true,
				showToast: true,
				toastMessage: "Image uploaded successfully",
				additionalData: { id },
			},
		});
	} catch (error) {
		// alert("B206 = " + `${error}`);
		console.error("Book - 213", error);
	}
};

export const deleteBookingImage =
	(id, params = {}) =>
	async (dispatch) => {
		try {
			await dispatch({
				[CALL_API]: {
					url: `/transaction/booking/${id}/images`,
					method: "DELETE",
					types: [
						DELETE_BOOKING_IMAGE,
						DELETE_BOOKING_IMAGE_SUCCESS,
						DELETE_BOOKING_IMAGE_FAILED,
					],
					params,
					showLoader: true,
					showToast: true,
					toastMessage: "Image deleted successfully",
					additionalData: params,
				},
			});
		} catch (error) {
			console.error("Book - 234", error);
			return { error };
		}
	};

// export const saveVehicleBookingImage = (body) => async (dispatch) => {
//   try {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/reservations/saveVehicleImages`,
//         method: "POST",
//         types: [
//           SAVE_VEHICLE_BOOKING_IMAGE,
//           SAVE_VEHICLE_BOOKING_IMAGE_SUCCESS,
//           SAVE_VEHICLE_BOOKING_IMAGE_FAILED,
//         ],
//         body,
//         showLoader: true,
//         showToast: true,
//         isForm: true,
//         otherUrl: true,
//       },
//     });
//   } catch (error) {
//     console.error("Book - 258", error);
//     //alert("B251 = " + `${error}`);
//   }
// };

export const savePrebookingImage = (vehId, body) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/prebooking/images?userVehicleId=${vehId}`,
				method: "POST",
				types: [
					SAVE_PREBOOK_IMAGE,
					SAVE_PREBOOK_IMAGE_SUCCESS,
					SAVE_PREBOOK_IMAGE_FAILED,
				],
				body,
				showLoader: true,
				showToast: true,
				toastMessage: "Image Uploaded Successfully",
				isForm: true,
			},
		});
	} catch (error) {
		// alert("B270 = " + `${error}`);
		console.error("Book - 279", error);
	}
};

export const deletePrebookingImage = (url, vehId) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/prebooking/images?url=${url}&userVehicleId=${vehId}`,
				method: "DELETE",
				types: [
					DELETE_PREBOOK_IMAGE,
					DELETE_PREBOOK_IMAGE_SUCCESS,
					DELETE_PREBOOK_IMAGE_FAILED,
				],
				showLoader: true,
				showToast: true,
				toastMessage: "Image Deleted Successfully",
			},
		});
	} catch (error) {
		// alert("B287 = " + `${error}`);
		console.error("Book - 297", error);
	}
};

export const deleteBookingTransaction = (id) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}`,
				method: "DELETE",
				types: [
					DELETE_BOOKING_TRANSACTION,
					DELETE_BOOKING_TRANSACTION_SUCCESS,
					DELETE_BOOKING_TRANSACTION_FAILED,
				],
				showLoader: true,
				showToast: true,
				toastMessage: "Booking deleted successfully",
			},
		});
	} catch (error) {
		// alert("B308= " + `${error}`);
		console.error("Book - 319", error);
	}
};

export const rescheduleBooking = (payload, id, toastMessage) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}`,
				method: "PATCH",
				body: payload,
				types: [RESCHEDULE, RESCHEDULE_SUCCESS, RESCHEDULE_FAILED],
				showLoader: true,
				showToast: true,
				toastMessage: !!toastMessage ? toastMessage : "Booking updated successfully",
			},
		});
	} catch (error) {
		// alert("B326 = " + `${error}`);
		console.error("Book - 338", error);
	}
};

export const cancelBooking = (id, toastMessage) => async (dispatch) => {
	try {
		await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}`,
				method: "DELETE",
				// body: payload,
				types: [RESCHEDULE, RESCHEDULE_SUCCESS, RESCHEDULE_FAILED],
				showLoader: true,
				showToast: true,
				toastMessage: !!toastMessage ? toastMessage : "Booking updated successfully",
			},
		});
	} catch (error) {
		// alert("B344 = " + `${error}`);
		console.error("Book - 357", error);
	}
};

export const getBookingEvents = (id) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}/event`,
				method: "POST",
				types: [
					GET_BOOKING_EVENTS,
					GET_BOOKING_EVENTS_SUCCESS,
					GET_BOOKING_EVENTS_FAILED,
				],
				body: {
					category: "Booking Status",
					name: "Awaiting for Garage/ Driver mapping",
					updatedAt: "2021-02-15T20:55:23Z",
				},
				showLoader: false,
			},
		});
	} catch (error) {
		// alert("B364 = " + `${error}`);
		console.error("Book - 378", error);
	}
};

export const getWorkshopImages = (id) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/reservations/${id}/images`, // /transaction/booking/${id}/event`,
				method: "GET",
				types: [
					GET_WORKSHOP_IMAGES,
					GET_WORKSHOP_IMAGES_SUCCESS,
					GET_WORKSHOP_IMAGES_FAILED,
				],
				showLoader: false,
				otherUrl: true,
			},
		});
	} catch (error) {
		console.error("Book - 394", error);
	}
};

export const fetchFeedback = () => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/settings/feedback-templates?clientName=${CLIENT_NAME}`,
				method: "GET",
				types: [
					FETCH_FEEDBACK_QUESTIONS,
					FETCH_FEEDBACK_QUESTIONS_SUCCESS,
					FETCH_FEEDBACK_QUESTIONS_FAILED,
				],
				showLoader: false,
			},
		});
	} catch (error) {
		// alert("B399 = " + `${error}`);
		console.error("Book - 414", error);
	}
};

export const razorpayCallBack =
	(success, code, desc, error, field, id, ordId, payId, signature) =>
	async (dispatch) => {
		try {
			return await dispatch({
				[CALL_API]: {
					url: success
						? `/transaction/payment/callback?razorpay_order_id=${ordId}&razorpay_payment_id=${payId}&razorpay_signature=${signature}&id=${id}`
						: `/transaction/payment/callback?code=${code}&description=${desc}&error=${error}&field=${field}&id=${id}`,
					method: "POST",
					body: {},
					types: [
						CALL_BACK_RAZORPAY,
						CALL_BACK_RAZORPAY_SUCCESS,
						CALL_BACK_RAZORPAY_FAILED,
					],
					showLoader: true,
					showToast: true,
					additionalData: {
						showError: false,
					},
				},
			});
		} catch (error) {
			// alert("B422 = " + `${error}`);
			console.error("Book - 438", error);
		}
	};

export const saveFeedback = (id, body) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}/feedback`,
				method: "POST",
				types: [SAVE_FEEDBACK, SAVE_FEEDBACK_SUCCESS, SAVE_FEEDBACK_FAILED],
				body,
				showLoader: true,
				showToast: true,
				toastMessage: "Feedback Submitted",
			},
		});
	} catch (error) {
		// alert("B440= " + `${error}`);
		console.error("Book - 457", error);
	}
};

export const getFeedback = (id) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/${id}/feedback`,
				method: "GET",
				types: [GET_FEEDBACK, GET_FEEDBACK_SUCCESS, GET_FEEDBACK_FAILED],
				showLoader: true,
				additionalData: {
					showError: false,
				},
			},
		});
	} catch (error) {
		// alert("B458 = ============ " + `${error}`);
		console.error("Book - 476", error);
	}
};

export const bookingSummary = (params) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking-summary`,
				method: "GET",
				types: [
					GET_BOOKING_SUMMARY,
					GET_BOOKING_SUMMARY_SUCCESS,
					GET_BOOKING_SUMMARY_FAILED,
				],
				params,
				showLoader: true,
			},
		});
	} catch (error) {
		// alert("B474 = " + `${error}`);
		console.error("Book - 493", error);
	}
};

export const saveBookingDetailsHeaderStatus = (val) => {
	return {
		type: SAVE_BOOKING_DET_HEADER_STATUS,
		status: val,
	};
};
export const updateBookingSummary = (payload) => {
	return {
		data: payload,
		type: UPDATE_BOOKING_SUMMARY,
	};
};

export const clearParticularBooking = () => {
	return {
		type: CLEAR_PARTICULAR_BOOKING,
	};
};

export function logout() {
	return {
		type: LOGOUT_SUCCESS,
	};
}

export const getAdvancePaymentOrderId = (bkngId) => async (dispatch) => {
	try {
		return await dispatch({
			[CALL_API]: {
				url: `/transaction/booking/order/${bkngId}`,
				method: "GET",
				showLoader: true,
				types: [
					GET_ADVANCE_ORDERID,
					GET_ADVANCE_ORDERID_SUCCESS,
					GET_ADVANCE_ORDERID_FAILED,
				],
			},
		});
	} catch (error) {
		// alert("B514 = " + `${error}`);
		console.error("Book - 534", error);
	}
};

export const updateParticularBookingDetails = (bkngObj) => {
	return {
		bookingObj: bkngObj,
		type: UPDATE_PARTICULAR_BOOKING_DETAILS,
	};
};
export const updateReservationParticularBookingDetails = (reserBkngObj) => {
	return {
		reservationBookingObj: reserBkngObj,
		type: UPDATE_RESERVATION_PARTICULAR_BOOKING_DETAILS,
	};
};

export const clearBookingImages = () => {
	return {
		type: CLEAR_BOOKING_IMAGES,
	};
};

export const clearSavedFeedbackStatus = () => {
	return {
		type: CLEAR_SAVED_FEEDBACK_STATUS,
	};
};
